import { useMutation, useQueryClient } from '@tanstack/react-query';

import { roomsKeys } from '~teacher/hook/room/roomsKeys';

import { createRoomShareLink } from '../../../api/rooms/createRoomShareLink';
import { RoomDetail } from '../../../api/rooms/getRoomShareUrl';

/**
 * Mutation hook for updating room share link.
 */
export function useCreateRoomShareLinkMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRoomShareLink,
    onMutate: () => {
      /* Analytics!! */
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(roomsKeys.list());

      queryClient.setQueryData<RoomDetail>(roomsKeys.details(data.id), data);
    },
    retry: 1,
  });
}
